// extracted by mini-css-extract-plugin
var _1 = "VersionChanges-module__active--MZInf";
var _2 = "VersionChanges-module__animateUploadProgressBarWidth--q5hMZ";
var _3 = "VersionChanges-module__animatedBackground--qd61r";
var _4 = "VersionChanges-module__bar--Rvef9";
var _5 = "VersionChanges-module__barContainer--IQMmg";
var _6 = "VersionChanges-module__barContent--Q0g62";
var _7 = "VersionChanges-module__checkIcon--YWaDJ";
var _8 = "VersionChanges-module__checkIconContainer--oi0e9";
var _9 = "VersionChanges-module__checked--FHpdi";
var _a = "VersionChanges-module__cyclingButtons--sOatL";
var _b = "VersionChanges-module__cyclingContainer--ScIg9";
var _c = "VersionChanges-module__cyclingLabel--IaC82";
var _d = "VersionChanges-module__editorContainer--GMXdu";
var _e = "VersionChanges-module__editorRoot--MGX0C";
var _f = "VersionChanges-module__historicalPost--T6_Dy";
var _10 = "VersionChanges-module__modeSelectOption--oSt10";
var _11 = "VersionChanges-module__selectButton--at2Jw";
var _12 = "VersionChanges-module__selectButtonCaret--AjT5Q";
var _13 = "VersionChanges-module__selectButtonContent--q98oA";
var _14 = "VersionChanges-module__selectButtonText--fK5Ga";
var _15 = "VersionChanges-module__versionMeta--t3Fds";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "bar", _5 as "barContainer", _6 as "barContent", _7 as "checkIcon", _8 as "checkIconContainer", _9 as "checked", _a as "cyclingButtons", _b as "cyclingContainer", _c as "cyclingLabel", _d as "editorContainer", _e as "editorRoot", _f as "historicalPost", _10 as "modeSelectOption", _11 as "selectButton", _12 as "selectButtonCaret", _13 as "selectButtonContent", _14 as "selectButtonText", _15 as "versionMeta" }
